import React from 'react'
import classNames from 'classnames'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { CaptionXS, EyebrowMD, EyebrowXS, TitleXS } from '@/atoms/Text'
import { slugs } from '@/constants'
import { useTranslate } from '@/utils/translate/translate-client'
import { BaseTooltip, BaseTooltipProps } from '.'

interface SpecificTimesToolTipProps extends BaseTooltipProps {
  extraSmall?: boolean
}

export const SpecificTimesToolTip: React.FC<SpecificTimesToolTipProps> = ({
  iconSize = 16,
  className,
  buttonClassName,
  panelClassName,
  panelPosition = 'CENTER',
  isIconOnly,
  buttonStyle,
  titleText,
  children,
  buttonColor,
  textColor,
  extraSmall = false,
  slug,
}) => {
  const { t } = useTranslate('tickets')
  const trigger = (
    <>
      {!isIconOnly && children ? (
        children
      ) : (
        <>
          {!extraSmall && (
            <EyebrowXS color={textColor} className={classNames('@md:!photon-eyebrow-md text-black/80')}>
              {titleText ? titleText : t('forSpecificTimes', 'FOR SPECIFIC TIMES')}
            </EyebrowXS>
          )}
          {extraSmall && (
            <CaptionXS color={textColor} className={'text-black/80'}>
              {titleText ? titleText : t('forSpecificTimes', 'FOR SPECIFIC TIMES')}
            </CaptionXS>
          )}
        </>
      )}
      <CircleInfoIcon size={iconSize} color={buttonColor || 'black'} />
    </>
  )

  const content = (() => {
    if (slug === slugs.kingOfKings) {
      return (
        <>
          <TitleXS color="core-gray-950" weight="bold">
            {t('tkokopening', 'Opening Weekend Showtimes (April 10–13) Only\n')}
          </TitleXS>
          <div className="mt-2 flex flex-col gap-0.5 text-[0.688rem] leading-[16px]">
            <EyebrowMD color="core-gray-700" className="block">
              {t('Thurs', 'THURS')} <span className="uppercase">({t('allDaytkok', 'ALL DAY')})</span>
            </EyebrowMD>
            <EyebrowMD color="core-gray-700" className="uppercase">
              {t('friBefore5AndAfter9', 'Fri (Before 5pm & After 9pm)')}
            </EyebrowMD>
            <EyebrowMD color="core-gray-700" className="uppercase">
              {t('satToSunAfter9', 'Sat-Sun (After 9pm)')}
            </EyebrowMD>
          </div>
        </>
      )
    }
    return (
      <>
        <TitleXS color="core-gray-950" weight="bold">
          {t('specificShowTimesDetails', 'Specific Showtimes Details')}
        </TitleXS>
        <div className="mt-2 flex flex-col gap-0.5 text-[0.688rem] leading-[16px]">
          <EyebrowMD color="core-gray-700" className="block">
            {t('monWedThurs', 'Mon, Wed & Thurs')} <span className="uppercase">({t('allDay', 'All Day')})</span>
          </EyebrowMD>
          <EyebrowMD color="core-gray-700">{t('friBefore5AndAfter9', 'Fri (Before 5pm & After 9pm)')}</EyebrowMD>
          <EyebrowMD color="core-gray-700">{t('satToSunAfter9', 'Sat-Sun (After 9pm)')}</EyebrowMD>
        </div>
      </>
    )
  })()

  return (
    <BaseTooltip
      className={className}
      buttonClassName={buttonClassName}
      panelClassName={panelClassName}
      panelPosition={panelPosition}
      isIconOnly={isIconOnly}
      removeBorder={true}
      buttonStyle={buttonStyle}
      trigger={trigger}
      content={content}
    />
  )
}
